import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "../../hooks";
import { SEARCH_V2_QUERY_URL, searchMicroservice } from "./api";

export interface SearchPrototypeParams {
  baseUrl: string;
  query: string | undefined;
  debounceMs?: number;
  enabled?: boolean;
  useSearchV2?: boolean;
}

function fetchV2(query: string): Promise<Response> {
  const url = new URL(SEARCH_V2_QUERY_URL);
  url.searchParams.set("q", query);
  url.searchParams.set("limit", "50");
  return fetch(url);
}

export function useSearchMicroservice({
  baseUrl,
  query,
  debounceMs = 300,
  enabled = true,
  useSearchV2 = false,
}: SearchPrototypeParams) {
  const debouncedSearchQuery = useDebounce(query, debounceMs);

  return useQuery({
    enabled: enabled && Boolean(debouncedSearchQuery),
    queryKey: ["search-microservice", debouncedSearchQuery, useSearchV2],
    queryFn: () => {
      const q = debouncedSearchQuery || "";
      if (useSearchV2) {
        return fetchV2(q).then((res) => res.json());
      }
      fetchV2(q).catch(() => {});
      return searchMicroservice(baseUrl, q);
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
}
